<template>
  <v-container fluid>
    <v-row class="section">
      <span class="title">Currently:</span>
    </v-row>
    <v-row v-for="(datum, index) in command.data.currently" :key="index">
      <v-col class="tech">{{ datum.tech }}</v-col>
      <v-col>{{ level[datum.class] }}</v-col>
    </v-row>
    <v-row class="section">
      <span class="title">Used in the past:</span>
    </v-row>
    <v-row v-for="(datum, index) in command.data.past" :key="index">
      <v-col class="tech">{{ datum.tech }}</v-col>
      <v-col>{{ level[datum.class] }}</v-col>
    </v-row>
    <v-row class="section">
      💪: Advanced | 👌: Intermediate | 🤓: Basic
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'skills',
  props: ['command'],
  data() {
    return {
      level: {
        1: '🤓',
        2: '👌',
        3: '💪'
      }
    };
  }
};
</script>

<style scoped>
.section {
  border-bottom: 1px dashed white;
  padding-top: 15px;
}

.title {
  color: #009b64ba;
  font-size: 24px;
}

.section:last-child {
  padding-bottom: 5px;
  border-top: 1px dashed white;
  border-bottom: none;
}
.col {
  text-align: left;
  padding: 6px;
  line-height: 90%;
}
</style>
